<template>
  <es-popup
    show="{{show}}"
    position="bottom"
    closeable
    bind:close="closePopup"
  >
    <view class="main" wx:if="{{currentItem?.status_name}}">
      <view class="title">
        <hl-text
          text="{{title}}"
          commonStyle="{{commonStyle}}"
          hlStyle="{{hlStyle}}" 
        />
      </view>
      <view class="sub-title">抢票失败，全额退款</view>
      <view class="package-select">
        <block wx:for="{{list}}" wx:key="index" >
          <view class="package-select-item" 
            wx:if="{{index}}"
            wx:class="{{{'active': currentIndex === index,'disabled': item.disable == 1}}}"
            bindtap="handleClick(item,index)">
            <view class="item-title">{{item.status_name}}</view>
            <view class="item-price" wx:if="{{item.status && item.disable == 0}}">
              <view class="item-price-after">¥{{item.show_price}}</view>
              <view wx:if="{{item.amount}}" class="item-price-before">¥{{item.price}}</view>
            </view>
            <view class="active-wrap">
              <image wx:if="{{currentIndex === index}}" class="active-image" src="{{activeIcon}}"></image>
            </view>
          </view>
        </block>
      </view>
      <view class="tips">
        <hl-text
          text="{{tipsText}}"
          commonStyle="{{tipsCommonStyle}}"
          hlStyle="{{tipsHlStyle}}" 
        />
      </view>
      <view class="footer">
        <view class="btn" bindtap="submit">确认使用 ¥{{currentItem.show_price}}</view>
      </view>
    </view>
  </es-popup>
</template>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'  
  import store from '@/store'
  import { makePackage, makePackagePay } from '@/api/order-detail/index'
  import { payment as payMgr } from '@/bridge'
  import { LOAD_FAIL_CONTENT } from '@/common/constant'

  createComponent({
    props: {
      show: false
    },
    data:{
      title:"提升抢票速度，{{成功率更高}}",
      hlStyle: {
        color: '#FF5900',
        fontFamily: 'PingFang SC',
        fontWeight: 500,
        fontSize: '19px',
        lineHeight: '19px',
      },
      commonStyle: {
        color: '#000000',
        fontFamily: 'PingFang SC',
        fontWeight: 500,
        fontSize: '19px',
        lineHeight: '19px',
      },
      tipsCommonStyle:{
        color: '#333333',
        fontFamily: 'PingFang SC',
        fontWeight: 500,
        fontSize: '12px',
        lineHeight: '12px',
      },
      tipsHlStyle: {
        color: '#FF5900',
        fontFamily: 'PingFang SC',
        fontWeight: 500,
        fontSize: '12px',
        lineHeight: '12px',
      },
      currentIndex:'',
      defalutIndex:'',
      activeIcon:"https://ut-static.udache.com/webx/sfc/xlrJai5eoFFVAo6v-C5bt.png",
    },
    attached(){
      this.defalutIndex = this.list.findIndex((item) => item.disable == 0)
    },
    computed: {
       ...store.mapState({
        packageInfo: 'order.package_info',
        baseInfo: 'order.base_info',
        token: 'user.token',
      }),
      list(){
        return this.packageInfo.packages || []
      },
      currentItem(){
        return this.currentIndex? this.list[this.currentIndex]: {}
      },
      tipsText(){
        return this.currentItem?.amount
          ? `已使用加速包{{${this.currentItem.amount}}}个，已抵扣{{${this.currentItem.deduct_price/100}}}元`
          : ''
      },
    },
    methods: {
      closePopup() {
        this.triggerEvent('close')
      },
      handleClick(item,index) {
        if(item.disable ==1 ) return
        this.currentIndex = index
      },
      submit(){
        makePackage({
          order_id: this.baseInfo.order_id,
          status: this.packageInfo.status,
          package: this.currentItem,
          added_service_source: JSON.stringify(['order_detail_float__accelerate']) // 记录加速包购买位置
        }).then(res => {
          const { data, message, code, success } = res || {}
          if (success && code === '0') {
            this.closePopup()
            const { extra_id, need_pay } = data
            if(need_pay){
              this.makePackagePay({extra_id})
            }else{
              // 刷新接口
              this.triggerEvent('refresh')
            }
            
          } else {
            this.showRequestErrorToast(message)
          }
        }).catch(err => {
          this.showRequestErrorToast()
        })
      },
      showRequestErrorToast(message) {
        mpx.showToast({
          title: message || LOAD_FAIL_CONTENT,
          icon: 'error'
        })
      },
      onPayment(out_trade_id) {
        if (__mpx_mode__ === 'web') {
          const { token } = this
          const payRes = payMgr.pay({
            out_trade_id: out_trade_id,
            token: token
          })
          payRes.then((res) => {
              // this.fetchTrainOrderDetailFunc()
              // 刷新接口
              this.triggerEvent('refresh')
              trackEvent('package-success', '排查--支付--package成功回调上报', { order_type : 'package' })
            })
            .catch((err) => {
              trackEvent('scramble-success', '排查--支付--package失败上报', { payRes: err })
            }).finally(()=>{
              trackEvent('pay-finish', '排查--支付--package完成')
            })
        }
      },
      makePackagePay(option){
        const { extra_id } = option
        makePackagePay({
          order_id:this.baseInfo.order_id,
          pre_pay_type:1,
          biz_order_id:extra_id
        }).then(res => {
          const { data, message, code, success } = res || {}
          if (success && code === '0') {
            const { out_trade_id } = data
            this.onPayment(out_trade_id)
          } else {
            // this.showRequestErrorToast(message)
          }
        }).catch(err => {
          // this.showRequestErrorToast()
        })

      }
    },
    watch:{
      defalutIndex: {
        handler(val, old) {
          this.currentIndex = this.defalutIndex
        },
      },
      packageInfo:{
        handler(val, old) {
          this.defalutIndex = this.list.findIndex((item) => item.disable == 0)
        },
      }
    }
  })
</script>

<style lang="stylus" scoped>
.main
  padding-bottom 40px
  border-radius 12px 12px 0 0
  overflow hidden
  background: linear-gradient(103deg, #FFF5EE 2%, #E5F9F6 89%);
  .title
    margin 18px 0 0 20px
  .sub-title
    font-family: PingFang SC;
    font-size: 12px;
    font-weight: normal;
    line-height: 12px;
    letter-spacing: 0px;
    color: #666666;
    margin 9px 0 0 20px
  .package-select
    margin-top 24px
    padding 0px 20px
    display grid
    grid-template-rows: auto auto
    grid-template-columns: repeat(3, 1fr)
    grid-template-areas: "A1 A2 A3" "A4 A5 A5"
    grid-gap 9px 8px
    .package-select-item
      font-family PingFang SC
      height 48px
      border-radius 8px
      opacity 1
      background #FFFFFF
      border 0.5px solid #D1DBE9
      backdrop-filter blur(27.2px)
      display flex
      flex-direction column
      justify-content center
      align-items center
      position relative
      &:last-child
        grid-area A5
        border: 0.5px solid rgba(120, 62, 23, 0.2);
        .item-title
            color #783E17
          .item-price
            .item-price-after
              color rgba(120, 62, 23, 0.9)
            .item-price-before
              color rgba(120, 62, 23, 0.5)
        .active-wrap
          background linear-gradient(143deg, #DC9626 -64%, #F9CD87 84%)
      &:last-child.active
        background: linear-gradient(168deg, #FEF9F2 8%, #FFF1DB 136%)
        border: 1px solid #F9CD87
      &:last-child::after
        content ''
        position absolute
        width 45px
        height 38px
        right 0px
        bottom 0px
        background-image url("https://ut-static.udache.com/webx/sfc/U4JbSF20KzyMjnBAQP2FD.png")
        background-size 100% 100%
        border-radius 0 0 8px 0
      .item-title
        font-family 'PingFang SC'
        font-size 14px
        font-weight 500
        line-height 14px
        text-align center
        letter-spacing 0px
        color #333333
      .item-price
        display flex
        flex-direction row
        margin-top 3px
        align-items baseline
        .item-price-after
          font-family 'PingFang SC'
          font-size 12px
          font-weight normal
          line-height 12px
          text-align center
          letter-spacing 0px
          margin-right 3px
          color #666666
        .item-price-before
          font-family 'PingFang SC'
          font-size 9px
          font-weight normal
          line-height 9px
          text-align right
          letter-spacing 0px
          color #999999
          text-decoration line-through
    .active
      background #FEF9F4
      box-sizing border-box
      border 1px solid #FF5900
      .item-price
        .item-price-after
          color #333333
      .active-wrap
        position absolute
        height 11px
        width 15px
        right -1px
        bottom -1px
        background #FF6400
        border-radius 8px 0
      .active-image
          width 5.5px
          height 4px
          position absolute
          right 3.5px
          bottom 2.5px
          z-index 2
    .disabled
      background linear-gradient(0deg, #E9EFF3, #E9EFF3)
      .item-title
        color #999999
  .tips
    margin 18px 0 0 20px
  .footer
    display flex
    align-items center
    justify-content center
    margin 12px 20px 0 20px
    .btn
      flex 1
      height: 50px;
      border-radius: 8px;
      background: #FF5900;
      color: #FFFFFF;
      font-family: PingFang SC;
      font-size: 16px;
      font-weight: 500;
      line-height: 50px;
      text-align center
</style>
<script name='json'>
  module.exports = {
    component: true,
    usingComponents: {
      'es-button': '@didi/es-mpx-ui/lib/button',
      'es-popup': '@didi/es-mpx-ui/lib/popup',
      'es-overlay': '@didi/es-mpx-ui/lib/overlay',
      'hl-text': '@/components/hl-text'
    }
  }
</script>